import { compose } from 'recompose';
import { connect } from 'react-redux';

import Footer from 'components/ModalFaqs/Sections/Footer/component';

const enhance = compose(connect(() => ({}), {}));

export default enhance(Footer);
